import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import Typography from '@material-ui/core/Typography'

const SidebarItem = ({ title, classes, children }) => {
  const [ expanded, setExpanded ] = useState(true)
  return (
    <ExpansionPanel
      expanded={expanded}
      className='SidebarItem'
      classes={{ root: classes.root }}
      onChange={(_, isActive) => { setExpanded(isActive) }}
    >
      <ExpansionPanelSummary
        expandIcon={expanded ? '-' : '+'}
        classes={{
          root: classes.panelHeader,
          expandIcon: classes.expandIcon
        }}
      >
        <Typography className={classes.heading}>
          {title}
        </Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails classes={{ root: classes.panelRoot }}>
        {children}
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}

SidebarItem.propTypes = {
  title: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  children: PropTypes.element.isRequired
}

const styles = {
  root: {
    boxShadow: 'none',
    '&:before': {
      display: 'none'
    }
  },
  heading: {
    fontSize: 14,
    letterSpacing: 1,
    textTransform: 'uppercase',
    color: '#1b1b1d'
  },
  expandIcon: {
    fontSize: 20,
    color: '#1b1b1d',
    right: 27
  },
  panelHeader: {
    padding: '0px 40px'
  },
  panelRoot: {
    padding: '8px 40px'
  }
}

export default withStyles(styles)(SidebarItem)
